import { isMobileViewport } from '../utilities/ViewportHelpers';


// custom ease registered for story animation (start slow, speed up, slow down at end)
if (typeof CustomEase !== "undefined") {
    CustomEase.create("speedUp2", "M0,0 C0.164,0.09 0.185,0.257 0.256,0.39 0.438,0.732 0.49,0.744 0.584,0.83 0.633,0.875 0.775,0.969 0.88,0.99 0.93,1 0.954,1 1,1 ")
}

document.addEventListener('DOMContentLoaded', () => {

    const c2g_hero_svg_el = document.querySelector('.c2g-hero svg') as SVGGraphicsElement;
    if (c2g_hero_svg_el) {
        const c2g_truck_svg_el = c2g_hero_svg_el.querySelector('#Truck') as SVGGraphicsElement;

        setTimeout(() => {
            // get svg viewbox width (not the same as window width AND width of the svg)
            const viewboxWidth = c2g_hero_svg_el.getBBox().width;

            const svgWidth = c2g_hero_svg_el.querySelector('#Scenes').getBoundingClientRect().width;
            const svgContainerWidth = c2g_hero_svg_el.closest('.story-wrapper').getBoundingClientRect().width;
            const truck_BoundingClientRect = c2g_truck_svg_el.getBoundingClientRect();
            // const cityTwoWidth = c2g_hero_svg_el.querySelector('#CityTwo').getBoundingClientRect().width;

            // NOTE: the svg viewbox height of 600px (v5) is being set to 680px on desktop, so we need to calculate this percentage increase and scale the translateX value down to the 600px equivalent
            const percentangeIncreaseDesktop = svgWidth / viewboxWidth;
            let translateX = -Math.abs(svgWidth / percentangeIncreaseDesktop) + (svgContainerWidth / percentangeIncreaseDesktop);

            if (isMobileViewport()) {
                // NOTE: svg width no longer same scale as viewbox (height reduced), so we need to calculate that viewbox width difference in order to get the right translateX value proportionate to the resized svg
                const percentageIncrease = 1 - (svgWidth / viewboxWidth);
                const allTheWayWidth = -Math.abs(svgWidth) + -Math.abs(viewboxWidth * percentageIncrease);

                translateX = allTheWayWidth + (document.documentElement.clientWidth * (1 + percentageIncrease));
                translateX += 90;   // small adjustment to middle align last city part
            }

            const c2bTl = gsap.timeline({ repeat: 0, repeatDelay: 0, paused: true });

            c2bTl.to('#tire_one, #tire_two, #tire_three', { duration: 20, rotation: 360 * 5, transformOrigin: "50% 50%", ease: "speedUp2" });
            c2bTl.to('#Scenes', { duration: 20, x: translateX, transformOrigin: "0 0", ease: "speedUp2" }, '<');

            if (!isMobileViewport()) {
                c2bTl.to(".c2g-hero .container", { duration: 2, top: 0, opacity: 1, transformOrigin: "0 0" }, '-=2');

                // move truck in line with the content
                const heroContent_BoundingClientRect = document.querySelector('.story-wrapper + .container > h1').getBoundingClientRect();
                if (truck_BoundingClientRect.x < heroContent_BoundingClientRect.x) {
                    c2bTl.to("#Truck", { duration: 2, x: (heroContent_BoundingClientRect.x - truck_BoundingClientRect.x) - 16, transformOrigin: "0 0" }, '-=4');
                }
            }

            c2bTl.play();
        }, 100);
    }
});